// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__k2VHB","label":"styles_label__PapMn","icon":"styles_icon__P54l1"};